module.exports = __webpack_public_path__ + "media/customizations/moonlight/back-9f6812fccd8250095b14f837e3f38cae.jpg";